// @ts-check

import BaseModel from "@kaspernj/api-maker/build/base-model.js"
import School from "./school.js"
import SchoolClass from "./school-class.js"
import User from "./user.js"

const modelClassData = {
  "attributes": {
    "created_at": {
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      },
      "name": "created_at",
      "selected_by_default": null,
      "translated": null
    },
    "created_user_id": {
      "column": {
        "default": null,
        "name": "created_user_id",
        "null": true,
        "type": null
      },
      "name": "created_user_id",
      "selected_by_default": null,
      "translated": null
    },
    "email": {
      "column": {
        "default": null,
        "name": "email",
        "null": false,
        "type": "string"
      },
      "name": "email",
      "selected_by_default": null,
      "translated": null
    },
    "existing_user_id": {
      "column": {
        "default": null,
        "name": "existing_user_id",
        "null": true,
        "type": null
      },
      "name": "existing_user_id",
      "selected_by_default": null,
      "translated": null
    },
    "id": {
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": null
      },
      "name": "id",
      "selected_by_default": null,
      "translated": null
    },
    "invited_by_user_id": {
      "column": {
        "default": null,
        "name": "invited_by_user_id",
        "null": false,
        "type": null
      },
      "name": "invited_by_user_id",
      "selected_by_default": null,
      "translated": null
    },
    "resource_id": {
      "column": {
        "default": null,
        "name": "resource_id",
        "null": false,
        "type": null
      },
      "name": "resource_id",
      "selected_by_default": null,
      "translated": null
    },
    "resource_type": {
      "column": {
        "default": null,
        "name": "resource_type",
        "null": false,
        "type": "string"
      },
      "name": "resource_type",
      "selected_by_default": null,
      "translated": null
    },
    "state": {
      "column": {
        "default": "new",
        "name": "state",
        "null": false,
        "type": "string"
      },
      "name": "state",
      "selected_by_default": null,
      "translated": null
    },
    "translated_state": {
      "column": null,
      "name": "translated_state",
      "selected_by_default": null,
      "translated": null
    },
    "updated_at": {
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      },
      "name": "updated_at",
      "selected_by_default": null,
      "translated": null
    }
  },
  "className": "SchoolClassInvitation",
  "collectionKey": "school_class_invitations",
  "collectionName": "school_class_invitations",
  "i18nKey": "school_class_invitation",
  "camelizedLower": "schoolClassInvitation",
  "name": "SchoolClassInvitation",
  "nameDasherized": "school-class-invitation",
  "pluralName": "school_class_invitations",
  "ransackable_associations": [
    {
      "className": "SchoolClassInvitation::Audit",
      "collectionName": "school_class_invitation_audits",
      "foreignKey": "school_class_invitation_id",
      "name": "audits",
      "macro": "has_many",
      "resource_name": "SchoolClassInvitationAudit",
      "through": null
    },
    {
      "className": "SchoolClassInvitation::Audit",
      "collectionName": "school_class_invitation_audits",
      "foreignKey": "school_class_invitation_id",
      "name": "create_audit",
      "macro": "has_one",
      "resource_name": "SchoolClassInvitationAudit",
      "through": null
    },
    {
      "className": "User",
      "collectionName": "users",
      "foreignKey": "created_user_id",
      "name": "created_user",
      "macro": "belongs_to",
      "resource_name": "User",
      "through": null
    },
    {
      "className": "User",
      "collectionName": "users",
      "foreignKey": "existing_user_id",
      "name": "existing_user",
      "macro": "belongs_to",
      "resource_name": "User",
      "through": null
    },
    {
      "className": "User",
      "collectionName": "users",
      "foreignKey": "invited_by_user_id",
      "name": "invited_by_user",
      "macro": "belongs_to",
      "resource_name": "User",
      "through": null
    },
    {
      "className": "Resource",
      "collectionName": null,
      "foreignKey": "resource_id",
      "name": "resource",
      "macro": "belongs_to",
      "resource_name": null,
      "through": null
    },
    {
      "className": "School",
      "collectionName": "schools",
      "foreignKey": "resource_id",
      "name": "school",
      "macro": "belongs_to",
      "resource_name": "School",
      "through": null
    },
    {
      "className": "SchoolClass",
      "collectionName": "school_classes",
      "foreignKey": "resource_id",
      "name": "school_class",
      "macro": "belongs_to",
      "resource_name": "SchoolClass",
      "through": null
    }
  ],
  "ransackable_attributes": [
    {
      "name": "created_at",
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "created_user_id",
      "column": {
        "default": null,
        "name": "created_user_id",
        "null": true,
        "type": null
      }
    },
    {
      "name": "email",
      "column": {
        "default": null,
        "name": "email",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "existing_user_id",
      "column": {
        "default": null,
        "name": "existing_user_id",
        "null": true,
        "type": null
      }
    },
    {
      "name": "id",
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": null
      }
    },
    {
      "name": "invited_by_user_id",
      "column": {
        "default": null,
        "name": "invited_by_user_id",
        "null": false,
        "type": null
      }
    },
    {
      "name": "resource_id",
      "column": {
        "default": null,
        "name": "resource_id",
        "null": false,
        "type": null
      }
    },
    {
      "name": "resource_type",
      "column": {
        "default": null,
        "name": "resource_type",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "role",
      "column": {
        "default": null,
        "name": "role",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "state",
      "column": {
        "default": "new",
        "name": "state",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "token",
      "column": {
        "default": null,
        "name": "token",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "updated_at",
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      }
    }
  ],
  "ransackable_scopes": [],
  "relationships": [
    {
      "className": "User",
      "collectionName": "users",
      "foreignKey": "created_user_id",
      "name": "created_user",
      "macro": "belongs_to",
      "resource_name": "User",
      "through": null
    },
    {
      "className": "User",
      "collectionName": "users",
      "foreignKey": "invited_by_user_id",
      "name": "invited_by_user",
      "macro": "belongs_to",
      "resource_name": "User",
      "through": null
    },
    {
      "className": "School",
      "collectionName": "schools",
      "foreignKey": "resource_id",
      "name": "school",
      "macro": "belongs_to",
      "resource_name": "School",
      "through": null
    },
    {
      "className": "SchoolClass",
      "collectionName": "school_classes",
      "foreignKey": "resource_id",
      "name": "school_class",
      "macro": "belongs_to",
      "resource_name": "SchoolClass",
      "through": null
    }
  ],
  "paramKey": "school_class_invitation",
  "primaryKey": "id"
}

/** Frontend model for SchoolClassInvitation. */
export default class SchoolClassInvitation extends BaseModel {
  /** @returns {typeof modelClassData} */
  static modelClassData() {
    return modelClassData
  }

  /** @returns {Date} */
  createdAt() {
    return this.readAttributeUnderscore("created_at")
  }

  /** @returns {boolean} */
  hasCreatedAt() {
    const value = this.createdAt()

    return this._isPresent(value)
  }

  /** @returns {any | null} */
  createdUserId() {
    return this.readAttributeUnderscore("created_user_id")
  }

  /** @returns {boolean} */
  hasCreatedUserId() {
    const value = this.createdUserId()

    return this._isPresent(value)
  }

  /** @returns {string} */
  email() {
    return this.readAttributeUnderscore("email")
  }

  /** @returns {boolean} */
  hasEmail() {
    const value = this.email()

    return this._isPresent(value)
  }

  /** @returns {any | null} */
  existingUserId() {
    return this.readAttributeUnderscore("existing_user_id")
  }

  /** @returns {boolean} */
  hasExistingUserId() {
    const value = this.existingUserId()

    return this._isPresent(value)
  }

  /** @returns {any} */
  id() {
    return this.readAttributeUnderscore("id")
  }

  /** @returns {boolean} */
  hasId() {
    const value = this.id()

    return this._isPresent(value)
  }

  /** @returns {any} */
  invitedByUserId() {
    return this.readAttributeUnderscore("invited_by_user_id")
  }

  /** @returns {boolean} */
  hasInvitedByUserId() {
    const value = this.invitedByUserId()

    return this._isPresent(value)
  }

  /** @returns {any} */
  resourceId() {
    return this.readAttributeUnderscore("resource_id")
  }

  /** @returns {boolean} */
  hasResourceId() {
    const value = this.resourceId()

    return this._isPresent(value)
  }

  /** @returns {string} */
  resourceType() {
    return this.readAttributeUnderscore("resource_type")
  }

  /** @returns {boolean} */
  hasResourceType() {
    const value = this.resourceType()

    return this._isPresent(value)
  }

  /** @returns {string} */
  state() {
    return this.readAttributeUnderscore("state")
  }

  /** @returns {boolean} */
  hasState() {
    const value = this.state()

    return this._isPresent(value)
  }

  /** @returns {any} */
  translatedState() {
    return this.readAttributeUnderscore("translated_state")
  }

  /** @returns {boolean} */
  hasTranslatedState() {
    const value = this.translatedState()

    return this._isPresent(value)
  }

  /** @returns {Date} */
  updatedAt() {
    return this.readAttributeUnderscore("updated_at")
  }

  /** @returns {boolean} */
  hasUpdatedAt() {
    const value = this.updatedAt()

    return this._isPresent(value)
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  static accept(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (BaseModel._callCollectionCommand(
      {
        args,
        command: "accept",
        collectionName: "school_class_invitations",
        type: "collection"
      },
      commandArgs
    ))
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  static findByToken(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (BaseModel._callCollectionCommand(
      {
        args,
        command: "find_by_token",
        collectionName: "school_class_invitations",
        type: "collection"
      },
      commandArgs
    ))
  }

  /** @returns {import("./user.js").default | null} */
  createdUser() {
    return this._readBelongsToReflection({modelClass: User, reflectionName: "created_user"})
  }

  /** @returns {Promise<import("./user.js").default | null>} */
  loadCreatedUser() {
    if (!("createdUserId" in this)) throw new Error("Foreign key method wasn't defined: createdUserId")

    const id = this.createdUserId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "created_user",
        model: this,
        modelClass: User
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./user.js").default | null>} */
  ensureCreatedUserLoaded() {
    return this.ensureAssociationLoaded("created_user")
  }

  /** @returns {import("./user.js").default | null} */
  invitedByUser() {
    return this._readBelongsToReflection({modelClass: User, reflectionName: "invited_by_user"})
  }

  /** @returns {Promise<import("./user.js").default | null>} */
  loadInvitedByUser() {
    if (!("invitedByUserId" in this)) throw new Error("Foreign key method wasn't defined: invitedByUserId")

    const id = this.invitedByUserId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "invited_by_user",
        model: this,
        modelClass: User
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./user.js").default | null>} */
  ensureInvitedByUserLoaded() {
    return this.ensureAssociationLoaded("invited_by_user")
  }

  /** @returns {import("./school.js").default | null} */
  school() {
    return this._readBelongsToReflection({modelClass: School, reflectionName: "school"})
  }

  /** @returns {Promise<import("./school.js").default | null>} */
  loadSchool() {
    if (!("resourceId" in this)) throw new Error("Foreign key method wasn't defined: resourceId")

    const id = this.resourceId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "school",
        model: this,
        modelClass: School
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./school.js").default | null>} */
  ensureSchoolLoaded() {
    return this.ensureAssociationLoaded("school")
  }

  /** @returns {import("./school-class.js").default | null} */
  schoolClass() {
    return this._readBelongsToReflection({modelClass: SchoolClass, reflectionName: "school_class"})
  }

  /** @returns {Promise<import("./school-class.js").default | null>} */
  loadSchoolClass() {
    if (!("resourceId" in this)) throw new Error("Foreign key method wasn't defined: resourceId")

    const id = this.resourceId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "school_class",
        model: this,
        modelClass: SchoolClass
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./school-class.js").default | null>} */
  ensureSchoolClassLoaded() {
    return this.ensureAssociationLoaded("school_class")
  }
}
